import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  EventHeartListParams,
  FetchHeartInfoParams,
  GlobalHeartListParams,
  HoldHeartDetailListParams,
  HoldHeartListParams,
  UserGiftListParams,
  UserGiftStatParams,
} from '@module/apis/client-side/heart/type';
import type { PageListParams } from '@module/apis/type';

export const heartQueryKeys = createQueryKeys('heart', {
  fetchHeartInfo: (fetchHeartInfoParams?: FetchHeartInfoParams) => [fetchHeartInfoParams],
  fetchHeartUseList: (fetchHeartUseListParams: PageListParams) => [fetchHeartUseListParams],
  fetchHeartChargeList: (fetchHeartChargeListParams: PageListParams) => [fetchHeartChargeListParams],
  fetchHeartSumList: (fetchHeartSumListParams: PageListParams) => [fetchHeartSumListParams],
  fetchHeartFreeList: (fetchHeartFreeListParams: PageListParams) => [fetchHeartFreeListParams],
  fetchBjLevel: (fetchBjLevelParams: FetchHeartInfoParams) => [fetchBjLevelParams],
  fetchUserGiftChartData: (fetchUserGiftStatParams: UserGiftStatParams) => [fetchUserGiftStatParams],
  fetchUserGiftList: (fetchUserGiftListParams: UserGiftListParams) => [fetchUserGiftListParams],
  fetchEventHeartList: (fetchEventHeartListParams: EventHeartListParams) => [fetchEventHeartListParams],
  fetchHoldHeartList: (fetchHoldHeartListParams: HoldHeartListParams) => [fetchHoldHeartListParams],
  fetchHoldHeartDetailList: (fetchHoldHeartDetailListParams: HoldHeartDetailListParams) => [
    fetchHoldHeartDetailListParams,
  ],
  fetchGlobalHeartList: (fetchGlobalHeartListParams: GlobalHeartListParams) => [fetchGlobalHeartListParams],
});
